import { connect } from "react-redux"
import {
    clusterCancelModelUpdate,
    clusterApplyModelUpdate,
    clusterModerate
} from "../../../../actions/cluster-actions"
import ClusterEditFormActionButtonsWidget from "./ClusterEditFormActionButtonsWidget"

const mapStateToProps = ({ presentation: { clusters } }, props) => ({
    moderationStatus: clusters.workingModel.status === "Active",
    canSave: clusters.canSave,
    canCancel: clusters.canCancel,
    isCreateMode: false,
    isSaving: clusters.isSavingItem,
    ...props
})

const mapDispatchToProps = dispatch => ({
    cancel: () => dispatch(clusterCancelModelUpdate()),
    save: () => dispatch(clusterApplyModelUpdate()),
    approve: () => dispatch(clusterModerate("Active")),
    reject: () => dispatch(clusterModerate("Archived")),
    unmoderate: () => null
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ClusterEditFormActionButtonsWidget)
